import * as types from "./types";

const defaultState = {

    memberList: [],

    member: {},

    industryList: [],

    memberTable: {

        tableHeaders: [
            "No.",
            "Name",
            "Batch Year",
            "Industry",
            "Designation",
            "Status",
            "Actions"
        ],
        tableColumns: [
            "memberNo",
            "memberName",
            "batchYear",
            "industryName",
            "occupation",
            "isSubscribed"
        ]
    },
    memberForm: {
        model: "MemberModel",
        form: [
            {
                type: "text",
                label: "Last name",
                placeholder: "Enter Last name",
                name: "lastName",
                default: '',
                required: true,
                md: 4,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                label: "First name",
                name: "firstName",
                placeholder: "Enter First name",
                required: true,
                default: '',
                md: 4,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                label: "Middle name",
                name: "middleName",
                placeholder: "Enter Middle name",
                required: true,
                default: '',
                md: 4,
                xs: 12,
                maxLength: 50
            },
            {
                type: "radio",
                label: "Gender",
                name: "gender",
                required: true,
                default: 'Male',
                md: 4,
                xs: 12,
                inline: true
            },
            {
                type: "datepicker", //data will be start date and end date
                required: true,
                md: 4,
                xs: 12,
                name: 'birthdate',
                label: "Date of Birth"
            },
            {
                type: "yearpicker", //data will be start date and end date
                required: true,
                md: 4,
                xs: 12,
                name: 'batchYear',
                label: "Batch Year"
            },
            {
                type: "text",
                label: "Contact Number",
                name: "contactNumber",
                placeholder: "Enter Contact number",
                required: true,
                default: '',
                md: 4,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                label: "Contact Number 2",
                name: "contactNumber2",
                placeholder: "Enter Contact number 2",
                default: '',
                md: 4,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                label: "Fax Number",
                name: "faxNumber",
                placeholder: "Enter Fax Number",
                default: '',
                md: 4,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                label: "Email Address",
                name: "emailAddress",
                placeholder: "Enter Email Address",
                required: true,
                default: '',
                md: 8,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                label: "Company",
                name: "company",
                placeholder: "Enter Company",
                required: true,
                default: '',
                md: 8,
                xs: 12,
                maxLength: 50
            },
            {
                type: "select",
                label: "Industry",
                name: "industryId",
                placeholder: "Select Industry",
                required: true,
                default: '',
                md: 4,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                label: "Occupation/Designation",
                name: "occupation",
                placeholder: "Enter Occupation",
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 50
            },
            {
                component: 'textarea',
                label: 'Company Description',
                name: 'companyDescription',
                placeholder: 'Description Here...',
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 255
            },
            {
                type: "text",
                label: "Address 1",
                name: "address1",
                placeholder: "Enter Address 1",
                required: true,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 100
            },
            {
                type: "text",
                label: "Address 2",
                name: "address2",
                placeholder: "Enter Address 2",
                required: false,
                default: '',
                md: 12,
                xs: 12,
                maxLength: 100
            },
            {
                type: "text",
                label: "City",
                name: "city",
                placeholder: "Enter City",
                required: true,
                default: '',
                md: 4,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                label: "State/Province",
                name: "stateProvince",
                placeholder: "Enter State/Province",
                required: true,
                default: '',
                md: 4,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                label: "Zip code",
                name: "zipCode",
                placeholder: "Enter Zip code",
                required: false,
                default: '',
                md: 4,
                xs: 12,
                maxLength: 50
            },
            {
                type: "select",
                label: "Country",
                name: "country",
                placeholder: "Select Country",
                required: true,
                default: '',
                md: 8,
                xs: 12,
                maxLength: 50
            },
            {
                type: "text",
                name: "empty",
                default: '',
                readOnly: true,
                md: 4,
            },
            {
                type: "checkbox",
                label: "Officer",
                name: "isOfficer",
                default: false,
                md: 2,
                xs: 12
            },
            {
                type: "checkbox",
                label: "Admin Rights",
                name: "adminRights",
                default: false,
                md: 2,
                xs: 12
            },
            {
                type: "checkbox",
                label: "Super Admin Rights",
                name: "superAdminRights",
                default: false,
                md: 2,
                xs: 12
            },
            {
                type: "dateRange", //data will be start date and end date
                required: true,
                default: '',
                md: 12,
                xs: 12,
                name: "subscriptionDate"
            },
        ]
    },
    renewalForm: {
        model: 'RenewalModel',
        form: [
            {
                type: "datepicker", //data will be start date and end date
                required: true,
                default: '',
                md: 12,
                xs: 12,
                name: "subscriptionEndDate",
                label: "Subscription End Date"
            },
            {
                type: "datepicker", //data will be start date and end date
                required: true,
                default: '',
                md: 12,
                xs: 12,
                name: "paymentDate",
                label: "Payment Date"
            },
        ]
    },

    radioInput: [
        {
            name: 'gender',
            label: 'Male',
            value: 'Male'
        },
        {
            name: 'gender',
            label: 'Female',
            value: 'Female'
        }
    ]


};

export default function reducer(state = defaultState, action) {
    switch (action.type) {

        case types.SET_LIST:
            return { ...state, memberList: action.payload };

        case types.SET_MEMBER:
            return { ...state, member: action.payload };

        case types.SET_INDUSTRY_LIST:
            return { ...state, industryList: action.payload };
        default: return state;
    }
}